import { forwardRef } from 'react';

import { Dialog } from '../dialog';
import { type FlexProps, Flex } from '../flex';
import { CircularProgress } from '../progress';
import { Text } from '../text';

interface LoadingProps extends FlexProps {
  fullscreen?: boolean;
}

const Loading = forwardRef<HTMLDivElement, LoadingProps>((props: LoadingProps, ref) => {
  const { fullscreen: isFullScreen = false, sx, ...restProps } = props;

  const content = (
    <Flex
      {...restProps}
      ref={ref}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        ...sx,
      }}
    >
      <CircularProgress />
      <Text sx={{ mt: 2 }}>กำลังโหลดข้อมูล...</Text>
    </Flex>
  );

  if (isFullScreen) {
    return (
      <Dialog open fullScreen>
        <Flex
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            height: '100dvh',
            bgcolor: (theme) => theme.palette.common.white,
          }}
        >
          {content}
        </Flex>
      </Dialog>
    );
  }

  return content;
});
Loading.displayName = 'Loading';

export default Loading;
